document.addEventListener("DOMContentLoaded", function(){
    function loop(cube, link){
      var currentFace = Number(cube.getAttribute("current-face"))
      cube.setAttribute("current-face", currentFace < 4 ? currentFace + 1 : 1)
      if(link != null){
        link.setAttribute("href", link.parentNode.getElementsByClassName("cube_link_" + cube.getAttribute("current-face"))[0].innerHTML)
      }
    }
    
    function beginInterval(carousel, cube, link, scrollSpeed){
      carousel.setAttribute('interval', setInterval(function () { loop(cube, link) }, scrollSpeed));
      //carousel.addEventListener('mouseover', function () { cancelInterval(carousel) });
      //carousel.addEventListener('mouseout', function () { beginInterval(carousel, cube, link, scrollSpeed) });
    }
    
    function cancelInterval(carousel) {
      clearInterval(parseInt(carousel.getAttribute('interval')));
    }
      
    const carousels = document.querySelectorAll(".ThreeDCarousel")
    carousels.forEach(carousel => {
        const cube = carousel.getElementsByClassName("cube")[0]
        const controls = carousel.getElementsByClassName("controls")[0]
        const next = controls.getElementsByClassName("next")[0]
        const prev = controls.getElementsByClassName("previous")[0]
        const link = carousel.getElementsByClassName("cube_blocks")[0].getElementsByClassName("three_d_carousel_link")[0]
        const scrollSpeed = carousel.getAttribute("speed")

        if(scrollSpeed){
          beginInterval(carousel, cube, link, scrollSpeed)
        }
      
        next.addEventListener("click", function(){
            var currentFace = Number(cube.getAttribute("current-face"))
            cube.setAttribute("current-face", currentFace < 4 ? currentFace + 1 : 1)
            if(link != null){
              link.setAttribute("href", link.parentNode.getElementsByClassName("cube_link_" + cube.getAttribute("current-face"))[0].innerHTML)
        }})

        prev.addEventListener("click", function(){
            var currentFace = Number(cube.getAttribute("current-face"))
            cube.setAttribute("current-face", currentFace > 1 ? currentFace - 1 : 4)
            if(link != null){
              link.setAttribute("href", link.parentNode.getElementsByClassName("cube_link_" + cube.getAttribute("current-face"))[0].innerHTML)
        }})
    })
})